import { memo, useState } from "react";
import { AnalyticsTopPost } from "../models/AnalyticsOverview";
import { MediaPlayer } from "./MediaPlayer";

export const AnalyticsPostThumbnail = memo(function AnalyticsPostThumbnail({
  post,
}: {
  post: AnalyticsTopPost;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  return (
    <div className="relative aspect-[16/10] overflow-hidden bg-muted">
      {post.media ? (
        <div className="pointer-events-none h-full w-full [&>div]:bg-muted">
          <MediaPlayer
            mediaItem={post.media}
            isControlsVisible={false}
            muted
            lazyLoadOverlays
            borderless
          />
        </div>
      ) : post.thumbnailUrl && post.thumbnailUrl !== failedUrl ? (
        <img
          key={post.thumbnailUrl}
          src={post.thumbnailUrl}
          alt=""
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer"
          className="h-full w-full object-cover"
          onError={() => setFailedUrl(post.thumbnailUrl!)}
        />
      ) : (
        <div className="flex h-full items-center justify-center bg-[oklch(0.96_0.025_32)] text-brand-ink">
          <span className="text-sm font-medium capitalize">{post.format}</span>
        </div>
      )}
    </div>
  );
});
